module.exports = __webpack_public_path__ + "img/training4.145ebce4.jpeg";